<template>
  <aside :class="['sidebar bg-dark text-white', { 'collapsed': isCollapsed }]">
    <!--div class="sidebar-header d-flex align-items-center justify-content-between p-3">
      <h5 v-if="!isCollapsed" class="mb-0">Menu</h5>
      <button class="btn btn-link text-white" @click="$emit('toggle-collapse')">
        <i class="fas fa-times"></i>
      </button>
    </div-->
    
    <ul class="nav flex-column">
      <li class="nav-item">
        <router-link to="/" class="nav-link" active-class="active">
          <i class="fas fa-home me-2"></i>
          <span v-if="!isCollapsed">Tableau de bord</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'users'}" class="nav-link" active-class="active">
          <i class="fas fa-user me-2"></i>
          <span v-if="!isCollapsed">Utilisateurs</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'projects'}" class="nav-link" active-class="active">
          <i class="fas fa-cog me-2"></i>
          <span v-if="!isCollapsed">Projets</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'messages'}" class="nav-link" active-class="active">
          <i class="fas fa-envelope me-2"></i>
          <span v-if="!isCollapsed">Messages</span>
          <!--span v-if="!isCollapsed" class="badge bg-danger float-end">5</span-->
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 250px;
  height: calc(100vh - 56px - 56px); /* 100vh - navbar - footer */
  position: fixed;
  top: 56px; /* Sous la navbar */
  left: 0;
  transition: width 0.3s;
  z-index: 1020;
  overflow-y: auto; /* Scroll si la sidebar est trop longue */
}

.sidebar.collapsed {
  width: 80px;
}

.nav-link {
  color: rgba(255, 255, 255, 0.8);
  padding: 0.75rem 1rem;
  transition: all 0.3s;
  white-space: nowrap;
}

.nav-link:hover, .nav-link.active {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-link span {
  transition: opacity 0.3s;
}

.sidebar.collapsed .nav-link span {
  display: none;
}

@media (max-width: 992px) {
  .sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s;
  }
  
  .sidebar.collapsed {
    transform: translateX(0);
    width: 250px;
  }
}
</style>